import { render, staticRenderFns } from "./heightCollapse.vue?vue&type=template&id=b2cc8bf8&scoped=true"
import script from "./heightCollapse.vue?vue&type=script&lang=js"
export * from "./heightCollapse.vue?vue&type=script&lang=js"
import style0 from "./heightCollapse.vue?vue&type=style&index=0&id=b2cc8bf8&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cc8bf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2cc8bf8')) {
      api.createRecord('b2cc8bf8', component.options)
    } else {
      api.reload('b2cc8bf8', component.options)
    }
    module.hot.accept("./heightCollapse.vue?vue&type=template&id=b2cc8bf8&scoped=true", function () {
      api.rerender('b2cc8bf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/heightCollapse.vue"
export default component.exports